// Shared on-scene accident protocol — shown to drivers on their phone and as a
// reference on the office Accident Protocol tab, so both stay in sync.
export const PROTOCOL_STEPS = [
  'Stop safely, turn on hazards, and check everyone for injuries — call 911 if anyone is hurt.',
  'Secure the scene: set out warning triangles. Move to a safe spot only if it is safe to do so.',
  'Do NOT admit fault or discuss who caused it with anyone.',
  'Call your supervisor / the office immediately.',
  'Photograph everything: all vehicles, all damage, license plates, the scene, and road conditions.',
  'Exchange info with the other driver(s); get names and numbers of any witnesses.',
  'Get the police report number and the officer’s name and badge number.',
  'A post-accident drug/alcohol test may be required — check with the office before leaving the scene.',
];
